import { Col } from '../../components/custom';

export default function LearningPrograms()
{
    return (
        <Col id='learningPrograms' className='perspectives'>
            <Col className='banner'>
                <span className='title'>Evaluating the Effectiveness of Learning Programs</span>
                <span className='desc'>Measure more than satisfaction — prove impact, drive improvement.</span>
            </Col>
            <Col className='section'>
                <span className='title'>The Challenge</span>
                <span className='desc bold'>Are your learning programs actually working?</span>
                <span className='descsmall'>Training feedback is often collected — but rarely analyzed meaningfully. Most organizations rely on basic satisfaction scores or smile sheets, missing out on deeper signals around knowledge retention, behavioral change, and on-the-job impact. Without that insight, it's difficult to improve programs, justify investments, or show real ROI.</span>
            </Col>
            <Col className='section'>
                <span className='title'>Our Philosophy</span>
                <span className='desc bold'>Go beyond happy sheets. Measure learning that sticks.</span>
                <span className='descsmall'>We believe learning analytics should not only capture how learners feel about a session — but also how that session influences what they do next. The goal is to evaluate training programs holistically: from engagement to effectiveness to business relevance.</span>
            </Col>
            <Col className='section'>
                <span className='title'>The Feedback Framework</span>
                <span className='desc'>A structured evaluation model that spans before, during, and after learning:</span>
                <ul>
                    <li className='descsmall'>
                        <strong>Multi-level Feedback Design</strong>
                        <ul>
                            <li className='descsmall'>Align to Kirkpatrick's 4 Levels: Reaction, Learning, Behavior, and Results.</li>
                            <li className='descsmall'>Customize surveys and feedback loops for each level of measurement.</li>
                        </ul>
                    </li>
                    <li className='descsmall'>
                        <strong>Sentiment & Emotion Analysis</strong>
                        <ul>
                            <li className='descsmall'>Use NLP to analyze open-ended responses and pull themes around facilitation, content clarity, and relevance.</li>
                            <li className='descsmall'>Detect pain points like outdated examples, too much theory, or unengaging formats.</li>
                        </ul>
                    </li>
                    <li className='descsmall'>
                        <strong>Behavioral & Performance Linkage</strong>
                        <ul>
                            <li className='descsmall'>Connect training participation to downstream behavior changes (e.g., sales lift, process adoption, quality improvement).</li>
                            <li className='descsmall'>Use dashboards to track training-to-performance pathways.</li>
                        </ul>
                    </li>
                    <li className='descsmall'>
                        <strong>Feedback Loop to Design Teams</strong>
                        <ul>
                            <li className='descsmall'>Feed back specific learner insights to L&D and facilitators for rapid course iteration.</li>
                            <li className='descsmall'>Flag modules needing redesign or deeper localization.</li>
                        </ul>
                    </li>
                </ul>
            </Col>
            <Col className='section'>
                <span className='title'>What This Enables</span>
                <ul>
                    <li className='descsmall'><strong>Learning ROI Visibility</strong> — Clearly link training outcomes to employee and business performance.</li>
                    <li className='descsmall'><strong>Content & Delivery Optimization</strong> — Improve modules based on actionable learner input.</li>
                    <li className='descsmall'><strong>Improved Engagement</strong> — Design learning experiences that are relevant, impactful, and aligned to role expectations.</li>
                    <li className='descsmall'><strong>Smarter Training Investments</strong> — Prioritize and scale programs that show measurable impact.</li>
                </ul>
            </Col>
            <Col className='section'>
                <span className='title'>The Takeaway</span>
                <span className='desc bold'>Training should teach, transform, and deliver results — not just tick a box.</span>
                <span className='descsmall'>With smart feedback analysis, organizations can elevate L&D from a cost center to a business driver.</span>
            </Col>
        </Col>
    )
}